import { Account, AccountAttributes, AccountRelationships } from 'dashboard/models/account';
import { FieldType } from 'lib/fields';
import { ApiModel } from 'lib/interfaces/api';

const createdAt = '2023-01-01T00:00:00.000Z';
const updatedAt = '2023-01-01T00:01:00.000Z';

export function createPreviewAccount(
  attributes?: Partial<AccountAttributes>,
  relationships?: Partial<AccountRelationships>,
  id?: string,
): Account {
  return {
    id: id || 'act_123',
    type: ApiModel.Account,
    attributes: {
      'created-at': createdAt,
      'updated-at': updatedAt,
      'reference-id': 'sw:ep_1',
      'name-full': 'Jane Doe',
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'selfie-photo-url': null,
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'redacted-at': null,
      fields: {
        name: {
          type: FieldType.Hash,
          value: {
            first: {
              type: FieldType.String,
              value: 'Jane',
            },
            middle: {
              type: FieldType.String,
              value: 'S',
            },
            last: {
              type: FieldType.String,
              value: 'Doe',
            },
          },
        },
        address: {
          type: FieldType.Hash,
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          value: {
            street_1: {
              type: FieldType.String,
              value: null,
            },
            street_2: {
              type: FieldType.String,
              value: null,
            },
            subdivision: {
              type: FieldType.String,
              value: 'Naboo',
            },
            city: {
              type: FieldType.String,
              value: null,
            },
            postal_code: {
              type: FieldType.String,
              value: null,
            },
            country_code: {
              type: FieldType.String,
              value: 'NB',
            },
          },
        },
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        birthdate: {
          type: FieldType.Date,
          value: null,
        },
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        phone_number: {
          type: FieldType.String,
          value: null,
        },
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        email_address: {
          type: FieldType.String,
          value: null,
        },
      },
      ...attributes,
    },
    relationships: {
      redactor: {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      ...relationships,
    },
  };
}
